import React, { useMemo } from "react";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function ScorePlusStatusChart({ records = [] }) {
  const chartData = useMemo(() => {
    const summary = {
      Done: 0,
      Partial: 0,
      Missed: 0,
    };

    records.forEach((r) => {
      if (summary[r.status] !== undefined) {
        summary[r.status]++;
      }
    });

    return {
      labels: Object.keys(summary),

      datasets: [
        {
          data: Object.values(summary),

          backgroundColor: ["#22c55e", "#f59e0b", "#ef4444"],

          borderColor: "#111827",

          borderWidth: 2,
        },
      ],
    };
  }, [records]);

  const options = {
    responsive: true,

    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "bottom",

        labels: {
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-xl p-5">
      <div className="text-lg font-semibold text-white mb-4">
        Completion Status
      </div>

      <div className="h-72">
        <Doughnut data={chartData} options={options} />
      </div>
    </div>
  );
}
